<!--
    描述：页面布局 —— 头部
    时间：2020-04-15
    Created by ws
-->
<template>
	<div class="home-page-header">
		<!-- logo -->
		<div class="logo-container">
			<img src="@/assets/images/dxsz_logo.png"
				 alt="">
			 <!--<img src="../../assets/images/logo_bm.png"
				 alt="">-->
			<!-- <img src="../../assets/images/logo_jk.png"
				 alt=""> -->
		</div>

		<!-- 系统文字 -->
		<div class="logo-text">
			<!-- <span class="mr10">|</span>造价数据分析系统-->
			<span class="mr10">|</span>鼎信造价数据库
		</div>

		<!-- 中间 menu -->
		<top-menu></top-menu>

		<!-- 个人信息 -->
		<right-info></right-info>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { dateFormat } from '@/utils/tools.js'
import rightInfo from './rightInfo'
import topMenu from './topMenu'

export default {
	components: {
		rightInfo,
		topMenu
	},
	data() {
		return {
			activeName: '',
			curTime: dateFormat()
		}
	},
	methods: {
		...mapActions('user', ['loginOut']),
		// 个人信息下拉框事件
		handleCommand(command) {
			switch (command) {
				case 'logOut':
					this.loginOut()
						.then(() => {
							this.$router.push({
								path: '/login'
							})
							setTimeout(() => {
								this.$message.success('退出成功!')
							}, 500)
						})
						.catch(() => {
							// this.btnLoading = false
						})
					break
				default:
					return
			}
		},
		// 选项卡 点击事件
		onTabClick(obj) {
			// console.log(obj.name)
			let _item = this.tabsList.find(x => x.name === obj.name)

			if (_item) {
				this.setActiveTab(obj.name)

				_item.name !== 'Home' ? this.setProjectId(obj.name) : ''

				this.$router.push({
					path: _item.path
				})
			}
			// console.log(this.tabsList)
		}
	},
	created() {},
	computed: {
		...mapState('settings', {
			isShowTab: state => state.showTabs
		}),
		...mapState('menu', {
			tabsList: state => state.tabsList,
			activeTab: state => state.activeTab
		}),
		...mapState('user', {
			userInfo: state => state.userInfo
		})
	}
}
</script>

<style scoped lang="less">
</style>
